// This helper exists to aid in testing of components that utilise print function.
// window.print() is a thread-blocking function, and not async like one can expect.
// By wrapping it in this promise, one can guarantee that in Production it will block the execution,
// but while testing it will be easier to mock the states per and post print action.
const sendToPrinter = async () => {
  print();
};

export default sendToPrinter;
